import { render, staticRenderFns } from "./bidding04.vue?vue&type=template&id=48a1990d&scoped=true&"
import script from "./bidding04.vue?vue&type=script&lang=js&"
export * from "./bidding04.vue?vue&type=script&lang=js&"
import style0 from "./bidding04.vue?vue&type=style&index=0&id=48a1990d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1990d",
  null
  
)

export default component.exports